// Import the functions you need from the SDKs you need
import {  initializeApp } from "firebase/app";
import { getToken, onMessage, getMessaging } from "firebase/messaging";
import { getAuth } from "firebase/auth";
import React from "react";
import FirebaseRepository from "core/data/FirebaseRepository";
import { IRegistrazioneFirebaseUtenteRequest } from "core/interfaces/data/IFirebaseRequest";
import { IBaseRequest } from "core/interfaces/data/Base";


//import { onBackgroundMessage } from "@firebase/messaging/sw";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

let config = window.CONFIG.FIREBASE;

const app = initializeApp(config.APP_CONFIG);

export const fireAut = getAuth(app);


export const fireMessaging = getMessaging(app);

export const getFirebaseToken = async (
	setTokenFound: React.Dispatch<React.SetStateAction<boolean>>,
	idSessione: string | undefined,
	culture: string
) => {
	if (window.CONFIG.FIREBASE.PUSH_NOTIFY_ENABLED) {
		//var sw = await window.navigator.serviceWorker.getRegistration("/firebase-messaging-sw.ts");
		var sw = await window.navigator.serviceWorker.getRegistration("/services/firebase-messaging-sw.js");
		let existingTokenReq: IBaseRequest = {
			IdSessione: idSessione,
			culture: culture,
		};
		let token = await FirebaseRepository.GetFirebaseToken(existingTokenReq);

		if (!token)
			token = await getToken(fireMessaging, { vapidKey: config.MESSAGING_KEY, serviceWorkerRegistration: sw })
				.then(async (currentToken) => {
					if (currentToken) {
						console.log("current token for client: ", currentToken);

						let req: IRegistrazioneFirebaseUtenteRequest = {
							TokenFCM: currentToken,
							IdSessione: idSessione,
							culture: culture,
						};

						let res = await FirebaseRepository.SetFirebaseToken(req);
						setTokenFound(res);

						// Track the token -> client mapping, by sending to backend server
						// show on the UI that permission is secured
					} else {
						console.log("No registration token available. Request permission to generate one.");
						setTokenFound(false);

						// shows on the UI that permission is required
					}
					return currentToken;
				})
				.catch((err) => {
					console.log("Errore in fase di recupero del token in firebase:", err);
					return undefined;
					// catch error while creating client token
				});

		return token;
	} else {
		return undefined;
	}
};

onMessage(fireMessaging, (payload) => {
	console.log("Message received. ", payload);

	alert(payload);
	// ...
});

export const onMessageListener = () =>
	new Promise((resolve) => {
		onMessage(fireMessaging, (payload) => {
			console.log("payload", payload);
			resolve(payload);
		});
	});

